import styled from '@emotion/styled/macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ActivityListItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`

export const ActivityItemWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const AppointmentActivityRemoveWrapper = styled.div`
  background: rgba(232, 69, 60, 0.3);
  border-radius: 12px;
  display: inline-block;
  height: 34px;
  left: 6%;
  width: 34px;
  margin: 0 10px;

  &:hover {
    background: rgba(232, 69, 60, 0.5);
    cursor: pointer;
  }
`

export const AppointmentActivityRemove = styled(FontAwesomeIcon)`
  color: red;
  display: block;
  font-size: 1rem;
  left: 1%;
  margin: 9px;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`

export const AppointmentActivityLockWrapper = styled.div<{ locked: boolean }>`
  background: ${({ locked }) =>
    locked ? 'rgba(232, 69, 60, 0.3)' : 'rgba(116, 224, 65, 0.3)'};
  border-radius: 12px;
  display: inline-block;
  height: 34px;
  left: 14%;
  width: 34px;
  margin: 0 10px;
  &:hover {
    background: ${({ locked }) =>
      locked ? 'rgba(232, 69, 60, 0.5)' : 'rgba(116, 224, 65, 0.5)'};
    cursor: pointer;
  }
`

export const AppointmentActivityLock = styled(FontAwesomeIcon)<{
  locked: boolean
}>`
  color: ${({ locked }) => (locked ? 'red' : 'green')};
  display: block;
  font-size: 1rem;
  left: ${({ locked }) => (locked ? '1%' : 0)};
  margin: 9px;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
`
